import { Box, Stack } from '@mui/material';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ReactElement } from 'react';

interface FrameProps {
  children: ReactElement;
  title?: string;
  toolbarButtons?: ReactElement;
  titleElement?: ReactElement;
}

export const Frame = ({
  children,
  title,
  toolbarButtons,
  titleElement,
}: FrameProps) => {
  return (
    <Stack className="frame" flexDirection="row">
      <Sidebar />
      <Stack flexGrow={1}>
        <Header
          title={title}
          toolbarButtons={toolbarButtons}
          titleElement={titleElement}
        />
        <Box
          className="main"
          p={4}
          maxHeight="calc(100vh - 100px)"
          overflow="auto">
          {children}
        </Box>
      </Stack>
    </Stack>
  );
};
